/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Evaporator } from "./modelEvaporator";

class ControllerEvaporator extends ControllerModel {
  constructor() {
    super("ControllerEvaporator");

    this.setNewNode = (callback) => {
      let evaporator = new Evaporator();
      evaporator.decorate(callback);

      this.addNode(evaporator);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let evaporator = new Evaporator();
      evaporator.copyFrom(node);
      evaporator.decorate(callback);
      this.addNode(evaporator);
    };

    this.getProperties = async (node) => {
      let n = new Evaporator();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Evaporator();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerEvaporator };
